<template>
  <div class="card border-0 radius-bottom-0" v-if="role">
    <div class="card-header bg-dark text-white row m-0 pt-4 pb-4">
      <div class="col-11">
        <h4 class="card-tite d-flex align-items-center">
          <font-awesome-icon icon="user" class="display-4 mr-3" />

          <span class="">
            <label class="form-label">Papel</label><br />
            {{ role.name }}
          </span>
        </h4>
      </div>

      <div class="col-1 d-flex align-items-end">
        <router-link
          v-if="$route.name != 'acl_edit'"
          :to="{
            name: 'acl_edit',
            params: { id: role.id },
          }"
          class="btn btn-outline-primary mr-2 link-edit"
          >Editar</router-link
        >

        <router-link
          v-else
          :to="{
            name: 'acl_show',
            params: { id: role.id },
          }"
          class="btn btn-outline-primary mr-2 link-edit d-none"
          >Visualizar</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("acl", ["role"]),
  },
  methods: {},
  async created() {},
};
</script>
